import { useMutation } from "@tanstack/react-query";

import { toast } from "react-toastify";

import { refreshNowApiCall, updateEnrollNowApiCall } from "./utils.api";

export const useUpdateEnrollNow = () =>
  useMutation({
    mutationFn: (body) => updateEnrollNowApiCall(body),
    onError: (error) => {
      const errorMessage =
        error instanceof Error ? error.message : "Enrollment failed";

      toast.error(errorMessage);
    },
  });

export const useRefreshNow = (options = {}) =>
  useMutation({
    mutationFn: async () => {
      const response = await refreshNowApiCall();
      return response;
    },

    onError: (error) => {
      const errorMessage =
        error instanceof Error ? error.message : "Something went wrong";

      toast.error(errorMessage);

      // Call consumer onError if provided
      options?.onError?.(error);
    },

    onSuccess: (data, variables, context) => {
      // Call consumer onSuccess if provided
      options?.onSuccess?.(data, variables, context);
    },
  });
